import React, { Fragment } from "react";
import clsx from 'clsx';

import Control from './Control';
import Box from "@mui/material/Box";
import Top from "@xem/icon/base/Top";
import Button from "reactstrap/lib/Button";
import WidgetBox from "@gqlapp/base/View/WidgetBox";
import Row from "@gqlapp/base/Row";
import Col from "@gqlapp/base/Col";
import Field from "@gqlapp/forms-client-react/FieldAdapter";
import RenderField from "@gqlapp/base/RenderField";
import RenderDropdownField from "@xem/look/Renders/Field/Dropdown";
import Radios from "@gqlapp/base/RenderRadiosBox";

import RenderSlider from "@gqlapp/base/RenderSlider";
import fontOptions from '@gqlapp/qrcode/utils/fonts';
import getStyle, { Frame, getOptions } from "./utils";
import FrameFont from './FrameFont';

export default function BaseForm(props) {
	let { values, setFieldValue, setScrollTop, zoomin } = props;
	
	let frame = values?.frame;
	const style       = frame?.style;
	const currentStyle = getStyle(style);
	const disableText = !!currentStyle?.disableText;
	const twoText     = currentStyle?.twoText;
	const maxFontSize = currentStyle?.maxFontSize;
	const options     = getOptions();
	
	return (<>
		<Box className={'frame'}>
			<Button
				onClick={() => setScrollTop(true)}
				color={'default'} className={clsx('p-0', 'circle-up', {'in': zoomin})}
				style={{ position: 'fixed', bottom: '60px', right: '2px', zIndex: 10 }}>
				<Top/>
			</Button>
			<FrameFont {...props} />
			<WidgetBox {...{ color: 'qrcode', title: 'qr:title.frame'.t(), className: 'qrcode-frame' }}>
				<Field
					{...{ component: Radios, control: <Control/> }}
					{...{ classNameGroup: 'frame-style qrcode-grid row row-small', classNameLabel: 'col-auto'}}
					{...{ value: frame?.style, name: 'frame.style', options, onChange: setFieldValue}}
				/>
			</WidgetBox>
		</Box>
	</>)
}